import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="App-main" style={{ textAlign: 'center', padding: '3rem 1rem' }}>
          <h2 style={{ marginBottom: '0.5rem' }}>Something went wrong</h2>
          <p className="status-text" style={{ maxWidth: '480px', margin: '0 auto 1.5rem' }}>
            We hit an unexpected error. Try refreshing the page or going back to the dashboard.
          </p>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
            <button
              className="primary-button"
              onClick={() => window.location.reload()}
            >
              Refresh page
            </button>
            <button
              className="secondary-button"
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.href = '/';
              }}
            >
              Go to home
            </button>
          </div>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre style={{ marginTop: '2rem', textAlign: 'left', fontSize: '0.75rem', color: '#999', overflow: 'auto', maxWidth: '600px', margin: '2rem auto 0' }}>
              {this.state.error.toString()}
            </pre>
          )}
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
